<template>
  <section class="footer-logos">
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/baiml.png"
        width="300"
        height="85"
        alt="Baiml logo"
      />
    </div>
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/snam.png"
        width="300"
        height="170"
        alt="Snam logo"
      />
    </div>
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/abtot.png"
        width="189"
        height="85"
        alt="Abtot logo"
      />
    </div>
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/uimla.png"
        width="85"
        height="85"
        alt="UIMLA logo"
      />
    </div>
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/eoca.png"
        width="147"
        height="85"
        alt="EOCA logo"
      />
    </div>
    <div class="logo-box">
      <NuxtPicture
        loading="lazy"
        format="webp"
        src="/images/logos/pro-mont-blanc.png"
        width="85"
        height="85"
        alt="Pro Mont Blanc logo"
      />
    </div>
  </section>
</template>
